import { AxiosApi } from "api";
import { IBuyer } from "interface/buyer";
import { ApiResponse } from "interface/response";
import { IUserLog, UserListItem, UserProfile } from "interface/user";
import { IUserProfileVessel } from "interface/vessel";

export async function adminUpdateUserApi(data: UserProfile) {
  const apiUri = "Administration/UpdateUser";

  try {
    const registrations = await AxiosApi.post<ApiResponse<any>>(apiUri, data);

    return registrations.data;
  } catch (error) {
    throw error;
  }
}

export async function addVesselToUserByAdminApi(data: {
  userId: string;
  vesselId: string;
  ledgerAccountNumber: string;
}) {
  const apiUri = "Administration/AddVesselToUser";

  try {
    const registrations = await AxiosApi.post<ApiResponse<any>>(apiUri, data);

    return registrations.data;
  } catch (error) {
    throw error;
  }
}

export async function removeVesselFromUserByAdminApi(data: {
  userId: string;
  vesselId: string;
  ledgerAccountNumber: string;
}) {
  const apiUri = "Administration/RemoveVesselFromUser";

  try {
    const registrations = await AxiosApi.post<ApiResponse<any>>(apiUri, data);

    return registrations.data;
  } catch (error) {
    throw error;
  }
}

export async function getUserVesselsApi(userId: string) {
  const apiUri = "Administration/UserProfileVessels";
  try {
    const registrations = await AxiosApi.get<ApiResponse<IUserProfileVessel[]>>(
      apiUri,
      { params: { userId } },
    );
    return registrations.data;
  } catch (error) {
    throw error;
  }
}

export async function adminUserProfileBuyersApi({
  userId,
}: {
  userId: string;
}) {
  const apiUri = "Administration/UserProfileBuyers";

  try {
    const registrations = await AxiosApi.get<ApiResponse<IBuyer[]>>(apiUri, {
      params: { userId },
    });

    return registrations.data;
  } catch (error) {
    throw error;
  }
}

export async function adminAddBuyerToProfileApi(data: {
  userId: string;
  buyerId: string;
}) {
  const apiUri = "Administration/AddBuyerToProfile";

  try {
    const registrations = await AxiosApi.post<ApiResponse<any>>(apiUri, data);

    return registrations.data;
  } catch (error) {
    throw error;
  }
}

export async function adminRemoveBuyerFromProfileApi(data: {
  userId: string;
  buyerId: number;
}) {
  const apiUri = "Administration/RemoveBuyerFromProfile";

  try {
    const registrations = await AxiosApi.post<ApiResponse<any>>(apiUri, data);

    return registrations.data;
  } catch (error) {
    throw error;
  }
}

export async function adminAddTerminalToProfileApi(data: {
  userId: string;
  terminalId: string;
}) {
  const apiUri = "Administration/AddTerminalToProfile";

  try {
    const registrations = await AxiosApi.post<ApiResponse<any>>(apiUri, data);

    return registrations.data;
  } catch (error) {
    throw error;
  }
}

export async function adminRemoveTerminalFromProfileApi(data: {
  userId: string;
  terminalId: string;
}) {
  const apiUri = "Administration/RemoveTerminalFromProfile";

  try {
    const registrations = await AxiosApi.post<ApiResponse<any>>(apiUri, data);

    return registrations.data;
  } catch (error) {
    throw error;
  }
}

export async function deleteUserApi(data: { userId: string }) {
  const apiUri = "Administration/DeleteUser";
  try {
    const registrations = await AxiosApi.post<ApiResponse<any>>(apiUri, data);

    return registrations.data;
  } catch (error) {
    throw error;
  }
}

export async function createNewUserApi(data: {
  email: string;
  firstName: string;
  lastName: string;
  phoneNumber: { prefix: string; number: string };
  roles?: string[];
}) {
  const apiUri = "Administration/CreateUser";

  try {
    const registrations = await AxiosApi.post<ApiResponse<any>>(apiUri, data);

    return registrations.data;
  } catch (error) {
    throw error;
  }
}

export async function getUserByIdApi(userId: string) {
  const apiUri = "Administration/GetUserById";

  try {
    const registrations = await AxiosApi.get<ApiResponse<UserProfile>>(apiUri, {
      params: { userId },
    });

    return registrations.data;
  } catch (error) {
    throw error;
  }
}

export async function getUserUniqueStringApi() {
  const apiUri = "user/UserUniqueString";

  try {
    const result = await AxiosApi.get<string>(apiUri);
    return result.data;
  } catch (error) {
    throw error;
  }
}

export async function getUsersNotMigratedApi(filter?: any) {
    const apiUri = "Administration/GetUsersNotMigrated";

  try {
    const userList = await AxiosApi.get<ApiResponse<UserListItem[]>>(
      apiUri,
      { params: filter },
    );
    return userList.data;
  } catch (error) {
    throw error;
  }
}

export async function migrateOldUserToNewLoginApi({
  userId,
}: {
  userId: string;
}) {
  const apiUri = "Administration/MigrateOldUser";

  try {
    const result = await AxiosApi.post<ApiResponse<any>>(apiUri, { userId });
    return result.data;
  } catch (error) {
    throw error;
  }
}

export async function getUserLogsApi(userId: string) {
    const apiUri = "Administration/UserLogs"
    try {
        const response = await AxiosApi.get<ApiResponse<IUserLog[]>>(apiUri, { params: { userId } })

        return response.data
    } catch (error) {
        throw error
    }
}